export default __webpack_public_path__ + "static/media/od-t_s.e81c4f09.jpg";